export default {
    async deleteInformation ({}, information) {
        let result = null;
        await this.$axios.$post(
            this.$api.systemAdmin.informations.delete,
            {
                id: information.id
            }
        )
        .then(response => {
            this.$alert.success(`「${information.target}」向けお知らせを削除しました`);
            result = 200;
        })
        .catch(error => {
        })
        return result;
    },
    async getInformationList ({}, params) {
        let result = null;
        await this.$axios.$post(
            this.$api.systemAdmin.informations.getList,
            {
                page: params.page,
                per_page: params.per_page
            }
        )
        .then(response => {
            result = response;
        })
        .catch(error => {
            result = {
                count: 0,
                page: 1,
                information_list:[]
            };
        })
        return result;
    },
    async getInformation ({}, id) {
        return await this.$axios.$post(
            this.$api.systemAdmin.informations.getDetail,
            {id: id}
        )
    },
    async editInformation ({}, data) {
        let result = null;
        await this.$axios.$post(
            this.$api.systemAdmin.informations.edit,
            data
        )
        .then(response => {
            result = 200;
        })
        .catch(error => {
        })
        return result;
    },
    async addInformation ({}, data) {
        let result = null;
        await this.$axios.$post(
            this.$api.systemAdmin.informations.register,
            data
        )
        .then(response => {
            result = 200;
        })
        .catch(error => {
        })
        return result;
    },
    async getTargetList ()  {
        return await this.$axios.$get(
            this.$api.systemAdmin.informations.getTargetList,
        )
    },
    async getTemplateList ()  {
        return await this.$axios.$get(
            this.$api.systemAdmin.informations.getTemplateList,
        )
    },
}